<template>
  <div class="pt-card-attribute input">
    <r-text style="margin-bottom: 8px;" type="caption">
      {{ config.label }}
    </r-text>
    <div class="pt-card-attribute-content">
      <el-select class="r-select" size="mini" v-model="feature[config.prop]">
        <el-option
          v-for="item in values[config.values]"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import cloneDeep from "lodash.clonedeep";
import { values } from "../config";

export default {
  props: ["feature", "config"],
  data() {
    return {
      values: cloneDeep(values)
    };
  },
  methods: {
    async getData() {
      try {
        const url = `objectInfo/${this.config.request}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });
        this.values[this.config.values] = Object.values(data);
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    if (this.config.request) {
      this.getData();
    }
  }
};
</script>

<style lang="scss">
.pt-card-attribute.input {
  .pt-card-attribute-content {
    .el-select {
      width: 100%;
    }
  }
}
</style>
